import { render, staticRenderFns } from "./FinanceSummary.vue?vue&type=template&id=187f7f68&scoped=true"
import script from "./FinanceSummary.vue?vue&type=script&lang=js"
export * from "./FinanceSummary.vue?vue&type=script&lang=js"
import style0 from "./FinanceSummary.vue?vue&type=style&index=0&id=187f7f68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187f7f68",
  null
  
)

export default component.exports